'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" {...props}><path fill="currentColor" fillRule="evenodd" d="M3.668 4.583h14.667v10.084H3.668zm-1.833 0c0-1.012.82-1.833 1.833-1.833h14.667c1.012 0 1.833.82 1.833 1.833v10.084c0 1.012-.82 1.833-1.833 1.833H3.668a1.833 1.833 0 0 1-1.833-1.833zm0 12.834a.917.917 0 1 0 0 1.833h18.333a.917.917 0 0 0 0-1.833z" clipRule="evenodd" /><path fill="currentColor" d="M13.378 8.934c.496.294.496 1.088 0 1.382l-4.101 2.425c-.466.276-1.027-.101-1.027-.69V7.2c0-.59.56-.967 1.027-.691z" /></svg>;
const IconTvWeb = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconTvWeb;